export default __webpack_public_path__ + "static/media/clock.2b397a0f.svg";